  const wishlist_api = 'https://shopify-wishlist.matat.io';
  class WishlistDrawer extends HTMLElement {
    constructor() {
      super();
      if (typeof customer_id !== 'undefined') {
            this.syncWithServer();
            this.syncWishlistToServer();
            this.renderContentFromSessionStorage();
      }
      this.createUniqueUserID();
      if (localStorage.getItem('visitCount')) {
        let visitCount = parseInt(localStorage.getItem('visitCount'));
        visitCount++;
        if (visitCount % 5 === 0) {
          this.syncWishlistToServer();
          visitCount = 0;
        }
        localStorage.setItem('visitCount', visitCount.toString());
      } else {
        localStorage.setItem('visitCount', '1');
      }
      this.renderContentFromSessionStorage();
      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      this.querySelector('#WishlistDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.setHeaderCartIconAccessibility();
    }
    syncWithServer(){
      var userId = localStorage.getItem('userId');
      if(userId!=customer_id){

      const endpoint = `${wishlist_api}/api/wishlist/sync`;
      const dynamicPayload = {
        user_id: userId,
        customer_id: customer_id
      };
      const dynamicPayloadJSON = JSON.stringify(dynamicPayload);
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: dynamicPayloadJSON,
      };
    
      fetch(endpoint, requestOptions)
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then(data => {
          localStorage.setItem('userId', customer_id);
        })
        .catch(error => {
        });
      }
    }
    createUniqueUserID(){
  // Check if the user ID already exists in local storage
      const existingUserId = localStorage.getItem('userId');

      if (!existingUserId) {
        // If it doesn't exist, generate a new user ID and save it to local storage
        const userId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
        localStorage.setItem('userId', userId);
        return userId;
      }
    }
    syncWishlistToServer(){
      var userId = localStorage.getItem('userId');
        // Define the endpoint with the user_id parameter
        const endpoint = `${wishlist_api}/api/wishlist/${userId}`;
        // Define the options for the fetch request
        const requestOptions = {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        };
        // Send the GET request
        fetch(endpoint, requestOptions)
          .then(response => {
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
            return response.json(); // If you expect a JSON response
          })
          .then(data => {
            // Handle the response data here
            let get_items =  JSON.parse(localStorage.getItem('wishlist_items'));
            if(get_items.length > 0){
              localStorage.setItem('wishlist_items', JSON.stringify(get_items));
            }else{
              localStorage.setItem('wishlist_items', JSON.stringify(data));  
            }
            this.renderContentFromSessionStorage();
          })
          .catch(error => {
            // Handle errors here
          });
    }
    setHeaderCartIconAccessibility() {
      const cartLink = document.querySelector('#wishlist-icon-bubble');
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink)
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    }
    open(triggeredBy) {
      if (triggeredBy) this.setActiveElement(triggeredBy);
      // const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
      // if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
      // here the animation doesn't seem to always get triggered. A timeout seem to help
      setTimeout(() => { this.classList.add('animate', 'active') });

      this.addEventListener('transitionend', () => {
        const containerToTrapFocusOn = document.getElementById('WishlistDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      }, { once: true });
      if(document.querySelector("#Details-menu-drawer-container").hasAttribute("open")){
        document.querySelector("#Details-menu-drawer-container").removeAttribute("open");
        document.querySelector("#Details-menu-drawer-container").classList.remove("menu-opening");
        document.querySelector(".header__icon--menu").setAttribute("aria-expanded",false);
        document.body.classList.remove("overflow-hidden-tablet");
        document.querySelector(".section-header").classList.remove("menu-open");
      }
      if(document.querySelector(".header__search details").hasAttribute("open")){
        document.querySelector(".header__search details").removeAttribute("open");
        document.querySelector(".section-header").classList.remove("menu-open");
      }
      document.body.classList.add('overflow-hidden');
    }
    close() {
      this.classList.remove('active');
      removeTrapFocus(this.activeElement);
      document.body.classList.remove('overflow-hidden');
    }
    setSummaryAccessibility(cartDrawerNote) {
      cartDrawerNote.setAttribute('role', 'button');
      cartDrawerNote.setAttribute('aria-expanded', 'false');

      if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
        cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
      }

      cartDrawerNote.addEventListener('click', (event) => {
        event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
      });

      cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
    }
    // Create a new wishlist image item
    appendWishlistImage(product) {
          const wishlistContainer = document.querySelector(".wishlist-container"); // Change selector if needed
      
          if (!wishlistContainer) return;
      
          const div = document.createElement("div");
          div.classList.add("wishlist-image-item");
      
          const anchor = document.createElement("a");
          anchor.href = product.url;
          anchor.classList.add("wishlist-product-wrap");
      
          const img = document.createElement("img");
          img.width = 150;
          img.height = 200;
          img.classList.add("attachment-woocommerce_thumbnail", "size-woocommerce_thumbnail", "lazyload");
          img.alt = "Product Image";
          img.decoding = "async";
      
          // Use data-src for lazy loading
          //img.setAttribute("data-src", product.src);
          // img.setAttribute("data-srcset", product.src);
          img.setAttribute("src", product.src);
          img.setAttribute("sizes", "(max-width: 150px) 100vw, 150px");
      
          // Append elements
          anchor.appendChild(img);
          div.appendChild(anchor);
          wishlistContainer.appendChild(div);
      }
      
    renderWishlistItem(product) {
      let product_media = product.src.split(",");
      var render_pro_image,pro_badges;
      var pro_compare_price = "";
      // if (product_media.length > 1) {
      //     render_pro_image = `
      //     <div class="wishlist-pro-slider">
      //       ${product_media.slice(0, 4).map(media => media ? `
      //         <div class="wishlist-image-item">
      //           <a href="${product.url}" class="wishlist-product-wrap">
      //             <img src="${media}" class="attachment-woocommerce_thumbnail size-woocommerce_thumbnail" alt="Product Image">
      //           </a>
      //         </div>
      //       ` : '').join('')}
      //     </div>
      //   `;
      // } else {
      //   render_pro_image = `
      //   <div class="wishlist-image-item">
      //     <a href="${product.url}" class="wishlist-product-wrap">
      //       <img width="150" height="200" src="${product.src}" class="attachment-woocommerce_thumbnail size-woocommerce_thumbnail" alt="Product Image" decoding="async" srcset="${product.src}" sizes="(max-width: 150px) 100vw, 150px">
      //     </a>
      //   </div>
      //   `;
      // }
      render_pro_image = document.createElement("div");
      render_pro_image.classList.add("wishlist-image-item");
  
      const anchor = document.createElement("a");
      anchor.href = product.url;
      anchor.classList.add("wishlist-product-wrap");
  
      const img = document.createElement("img");
      img.width = 150;
      img.height = 200;
      img.classList.add("attachment-woocommerce_thumbnail", "size-woocommerce_thumbnail", "lazyload");
      img.alt = "Product Image";
      img.decoding = "async";
  
      // Use data-src for lazy loading
      // img.setAttribute("data-src", product.src);
      // img.setAttribute("data-srcset", product.src);
      img.setAttribute("src", product.src);
      img.setAttribute("sizes", "(max-width: 320px) 100vw, 320px");
  
      // Append elements
      anchor.appendChild(img);
      render_pro_image.appendChild(anchor);
      
      if(product.saleBadge != "" || product.soldBadge != "" || product.tagBadge != ""){
        var sale_badge = "";
        var sold_badge = "";
        var tag_badge = "";
        console.log(product.saleBadge)
        if(  product.saleBadge != null && product.compare_price > product.price){
          sale_badge = `<span class="wishlist-sale-badge">${product.saleBadge}</span>`;
        }
        if(product.soldBadge != "" && product.soldBadge != undefined){
          sold_badge = `<span class="wishlist-sold-badge">${product.soldBadge}</span>`
        }
        if(product.tagBadge != "" && product.tagBadge != undefined){
          tag_badge = `<span class="wishlist-tag-badge">${product.tagBadge}</span>`
        }
        pro_badges = `<div class="wishlist-pro-badges">${sale_badge} ${sold_badge} ${tag_badge}</div>`
      }
      if(product.compare_price != "" && product.compare_price != undefined){
        pro_compare_price = `<span class="sale-wishlist-price amount">${product.compare_price}</span>`;
      }
      return `
        <wishlist-item class="product-col">
          <div class="product-item">
            <div class="img-wrap">
              <wishlist-item-delete-button class="btn-remove-wishlist" data-id="${product.id}" role="button" tabindex="0">
              <svg xmlns="http://www.w3.org/2000/svg" width="13.629" height="15.088" viewBox="0 0 13.629 15.088">
                <g id="Icon_feather-trash" data-name="Icon feather-trash" transform="translate(-4.25 -2.75)">
                  <path id="Path_7719" data-name="Path 7719" d="M4.5,9H17.629" transform="translate(0 -3.082)" fill="none" stroke="CurrentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="0.5"/>
                  <path id="Path_7720" data-name="Path 7720" d="M17.711,5.918V16.129a1.459,1.459,0,0,1-1.459,1.459H8.959A1.459,1.459,0,0,1,7.5,16.129V5.918m2.188,0V4.459A1.459,1.459,0,0,1,11.147,3h2.918a1.459,1.459,0,0,1,1.459,1.459V5.918" transform="translate(-1.541 0)" fill="none" stroke="CurrentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="0.5"/>
                </g>
              </svg>
              </wishlist-item-delete-button>
              ${render_pro_image.outerHTML}
              ${
                product.has_only_default_variant == "false" || product.has_only_default_variant == 0 || product.has_only_default_variant == false
                  ? `<a href="${product.url}" class="btn-add-cart demo">${wishlist.choose_option}</a>`
                  : `<add-to-cart href="${product.url}" class="btn-add-cart demo" data-variant-id="${product.variantId}" data-id="${product.id}"  role="button" tabindex="0">${wishlist.add_to_cart}</add-to-cart><form method="post" action="/cart/add" id="product-form-template--20440754225444__product-grid8653905461540" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form"><input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="id" value="${product.variantId}" class="product-variant-id"></form>`
              }
              ${pro_badges}
            </div>
            <div class="product_info_wrapper">
              <h3 class="product-name">
                <a href="${product.url}">${product.title}</a>
              </h3>
              <div class="product_inner_info">
                <div class="product-price">
                  ${pro_compare_price}
                  <span class="woocommerce-Price-amount amount"><bdi>${product.price}</bdi></span>
                </div>
                <div class="go_to_product">
                  <a href="${product.url}" class="go-top-product_btn button button--primary">${wishlist.choose_option}</a>
                </div>
              </div>
            </div>
          </div>
        </wishlist-item>`;
    }
    renderContentFromSessionStorage(){
      const storedData = JSON.parse(localStorage.getItem('wishlist_items') || '[]');
      const wishlistItemsElement = document.querySelector('wishlist-items');
      const wishlistButtons = document.querySelectorAll('wishlist-button');
      if (storedData.length >= 1) {
        const renderedItems = storedData.map(product => this.renderWishlistItem(product));
        wishlistItemsElement.innerHTML = renderedItems.join('\n');
        this.updateWishlistBubble();
        if(document.querySelector(".wishlist-pro-slider")){
          setTimeout(function(){ 
            document.querySelectorAll(".wishlist-pro-slider").forEach((ele) => {
              var flkty = new Flickity( ele, {
                "pageDots": true,
                "prevNextButtons": false,
                "wrapAround": true
            });
            })
           }, 300);
        }
      }
      wishlistButtons.forEach(button => {
        button.classList.toggle('has_in_wishlist', this.checkIfProductExistInWishlist(button.dataset.id));
      });

    }
    checkIfProductExistInWishlist(productId){
      const storedData = localStorage.getItem('wishlist_items');
      if (storedData) {
        const productData = JSON.parse(storedData);
        // Check if any product has the provided productId
        const exists = productData.some(product => product.id === productId);
        return exists;
      } else {
        return false; // Assuming product doesn't exist if no data is available
      }
    }
    updateWishlistBubble(){
      let layout = "";
      const storedData = localStorage.getItem('wishlist_items');
      if(storedData && JSON.parse(storedData).length >=1){
        var productData = JSON.parse(storedData);
        layout = `<div class="cart-count-bubble">
            <span aria-hidden="true">${productData.length}</span>
            <span class="visually-hidden">${productData.length} Items</span>
        </div>`;
        this.setDrawerStatus(true);
      }else{
        this.setDrawerStatus(false);
      }
      document.querySelector("#WishlistDrawer .drawer__heading span").innerHTML = `(${JSON.parse(storedData).length})`;
      document.querySelector('#wishlist-bubble-container').innerHTML = layout;
    }
    setActiveElement(element) {
      this.activeElement = element;
    }
    setDrawerStatus(status){
      let $this = this;
      if(status){
        $this.classList.remove('wishlist-empty');
      }else{
        setTimeout(()=>{
          $this.classList.add('wishlist-empty');
        },500)
      }
    }
    removeProductFromSessionStorage(productIdToRemove) {
      let storedData = localStorage.getItem('wishlist_items');
      if (storedData) {
        let jsonData = JSON.parse(storedData);
        let updatedData = jsonData.filter(product => product.id !== productIdToRemove);
        localStorage.setItem('wishlist_items', JSON.stringify(updatedData));
        this.updateWishlistBubble();
      }
      // this.renderContentFromSessionStorage();
    }
  }
  customElements.define('wishlist-drawer', WishlistDrawer);



  class WishlistItems extends HTMLElement{
    constructor() {
      super();

    }
  }
  customElements.define('wishlist-items', WishlistItems);



  class WishlistItem extends WishlistItems {
  }
  customElements.define('wishlist-item', WishlistItem);



  class WishlistDeleteButton extends WishlistItem {
    constructor() {
      super();
      this.addEventListener('click', this.removeItem);
    }

    removeItem(){
      let product_id = this.dataset.id;
      this.sendDeleteRequest(product_id);
      document.querySelector('wishlist-drawer').removeProductFromSessionStorage(product_id);
      this.fadeAndRemove(this.closest('wishlist-item'));

      const wishlistButtons = document.querySelectorAll('wishlist-button');
      wishlistButtons.forEach(button => {
        button.classList.toggle('has_in_wishlist', this.checkIfProductExistInWishlist(button.dataset.id));
      });
    }
    checkIfProductExistInWishlist(productId){
      const storedData = localStorage.getItem('wishlist_items');
      if (storedData) {
        const productData = JSON.parse(storedData);
        // Check if any product has the provided productId
        const exists = productData.some(product => product.id === productId);
        return exists;
      } else {
        return false; // Assuming product doesn't exist if no data is available
      }
    }
    fadeAndRemove(el) {
      var opacity = 1;
      var interval = setInterval(function() {
      if (opacity > 0) {
        opacity -= 0.1;
        el.style.opacity = opacity;
      } else {
        clearInterval(interval);
        el.style.display = 'none';
        el.remove()
      }
      }, 25);
    }

    sendDeleteRequest(itemId) {
      // Define the endpoint with the {id} parameter
      const endpoint = `${wishlist_api}/api/wishlist`;
    
      // Define the payload with the user_id
      const payload = {
            user_id: localStorage.getItem('userId'),
            product_id: itemId
        };
    
      // Convert the payload to JSON
      const payloadJSON = JSON.stringify(payload);
    
      // Define the options for the fetch request
      const requestOptions = {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        body: payloadJSON,
      };
    
      // Send the DELETE request
      fetch(endpoint, requestOptions)
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
        })
        .catch(error => {
          // Handle errors here
          console.error('Error:', error);
        });
    }


  }
  customElements.define('wishlist-item-delete-button', WishlistDeleteButton);


  class WishlistButton extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', this.handleButtonClicked);
      if(this.checkIfProductExistInWishlist(this.dataset.id)){
        this.classList.add('has_in_wishlist');
      }
    }

    handleButtonClicked(){
      let prod = this.getProductObject(this.dataset);
      if(this.classList.contains('has_in_wishlist')){
          this.classList.remove('has_in_wishlist');
          this.removeFromWishlist(prod);
      }else{
        this.classList.add('has_in_wishlist');
        this.addToWishlist(prod);
        setTimeout(()=>{
          this.openDrawer();
        },200);
      }
      document.querySelector('wishlist-drawer').renderContentFromSessionStorage()
    }

    addToWishlist(prod){
      this.appendJsonToSessionStorage(prod);
      this.sendWishlistItem(prod);
    }

    removeFromWishlist(prod){
      document.querySelector('wishlist-drawer').removeProductFromSessionStorage(prod.id);
      document.querySelector('wishlist-item-delete-button').sendDeleteRequest(prod.id);
    }

    openDrawer(){
      document.querySelector('wishlist-drawer').open()
    }

    getProductObject(prod){
      return {
        'has_only_default_variant': prod.has_only_default_variant,
        'id': prod.id,
        'title':  prod.title,
        'price_varies': prod.price_varies,
        'price': prod.price,
        'price_max': prod.price_max,
        'price_min': prod.price_min,
        'src': prod.src,
        'url': prod.url,
        'variantId': prod.variantId,
        'compare_price':prod.compareprice,
        'saleBadge': prod.salebadge,
        'soldBadge': prod.soldbadge,
        'tagBadge': prod.tagbadge

      }
    }

    appendJsonToSessionStorage(jsonData) {
      // Check if the session ID exists in session storage
      let existingData = localStorage.getItem('wishlist_items');
      if (existingData) {
        // If session data exists, parse it and append new JSON data
        let parsedData = JSON.parse(existingData);
        parsedData.push(jsonData);
        localStorage.setItem('wishlist_items', JSON.stringify(parsedData));
      } else {
        // If session data doesn't exist, create a new session with the JSON data
        localStorage.setItem('wishlist_items', JSON.stringify([jsonData]));
      }
    }



    checkIfProductExistInWishlist(productId){
      const storedData = localStorage.getItem('wishlist_items');
      if (storedData) {
        const productData = JSON.parse(storedData);
        // Check if any product has the provided productId
        const exists = productData.some(product => product.id === productId);
        return exists;
      } else {
        return false; // Assuming product doesn't exist if no data is available
      }
    }

    sendWishlistItem(prod) {
      // Get the user_id from local storage
      const userId = localStorage.getItem('userId');
      const endpoint = `${wishlist_api}/api/wishlist`;

      // Define the dynamic payload
      const dynamicPayload = {
        user_id: userId,
        ...prod
      };
      // Convert the dynamic payload to JSON
      const dynamicPayloadJSON = JSON.stringify(dynamicPayload);
    
      // Define the options for the fetch request
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: dynamicPayloadJSON,
      };
    
      // Send the POST request
      fetch(endpoint, requestOptions)
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json(); // If you expect a JSON response
        })
        .then(data => {
        })
        .catch(error => {
          // Handle errors here
          console.error('Error:', error);
        });
    }


  }
  customElements.define('wishlist-button', WishlistButton);


  class WishlistATCButton extends HTMLElement{
    constructor() {
      super();
      this.addEventListener('click', this.quickAddToCart);
    }
    quickAddToCart() {
      var $this = this;
      if(this.getAttribute("disabled")){
        alert('Clicked')
      }else{
        this.setAttribute("disabled", true);
        this.innerHTML = `<svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
            <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
        </svg>  הוספה לעגלה`;
        let product_id = this.dataset.id;
        var xhr = new XMLHttpRequest();
        xhr.open("POST", "/cart/add.js", true);
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.onreadystatechange = function () {
          if (xhr.readyState === 4) {
            if (xhr.status === 200) {
              var data = JSON.parse(xhr.responseText);
              // Success handling
              fetch(`${routes.cart_url}?sections=cart-drawer,cart-icon-bubble`)
              .then((response) => response.json())
              .then((response) => {
                  let responseFormated = {
                      sections: response,
                      ...data.items[0]
                  }
                  let cart_drawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
                  cart_drawer.renderContents(responseFormated);
                  $this.innerHTML = `הוספה לסל הקניות`;
                  if (cart_drawer && cart_drawer.classList.contains('is-empty')) cart_drawer.classList.remove('is-empty');
                  $this.removeAttribute("disabled");

                  document.querySelector('wishlist-item-delete-button').sendDeleteRequest(product_id);
                  document.querySelector('wishlist-drawer').removeProductFromSessionStorage(product_id);
                  document.querySelector('wishlist-drawer').renderContentFromSessionStorage();
              })
            } else {
              // Failure handling
              $this.innerHTML = `הוספה לסל הקניות`;
              $this.removeAttribute("disabled");
            }
          }
        };
        var data = JSON.stringify({
          items: [{
            id: this.dataset.variantId,
            quantity: 1
          }]
        });
        xhr.send(data);
      }
    }

    fadeAndRemove(el) {
      var opacity = 1;
      var interval = setInterval(function() {
      if (opacity > 0) {
        opacity -= 0.1;
        el.style.opacity = opacity;
      } else {
        clearInterval(interval);
        el.style.display = 'none';
        el.remove()
      }
      }, 25);
    }
  }
  customElements.define('add-to-cart', WishlistATCButton);

